import { Heading, Text } from "@chakra-ui/react";
import React from "react";
import BasicPage from "../BasicPage";
import SupportArea from "./SupportArea";

const ExpiredLinkPage = () => {
  return (
    <BasicPage type="modal">
      <Heading>Link expired</Heading>
      <Text fontSize="sm">
        You're seeing this because you clicked on a link to MakerKids (from an
        external website, or maybe an email) that has expired.
      </Text>
      <SupportArea />
    </BasicPage>
  );
};

export default ExpiredLinkPage;
